import { cn } from './utils';

interface SegmentedProps<T extends string> {
  value: T;
  onChange: (v: T) => void;
  options: readonly { value: T; label: string }[];
  label: string;
  className?: string;
}

/** Pill toggle group (legacy `.seg`), exposed as a radio group for accessibility. */
export function Segmented<T extends string>({
  value,
  onChange,
  options,
  label,
  className,
}: SegmentedProps<T>) {
  return (
    <div
      role="radiogroup"
      aria-label={label}
      className={cn(
        'no-scrollbar inline-flex max-w-full gap-0.5 overflow-x-auto rounded-full bg-soft p-1',
        className,
      )}
    >
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={value === o.value}
          onClick={() => onChange(o.value)}
          className={cn(
            'min-h-9 shrink-0 whitespace-nowrap rounded-full px-4 text-sm font-medium transition-[background-color,color,box-shadow] duration-200',
            value === o.value
              ? 'bg-panel text-ink shadow-[0_2px_6px_-2px_rgb(40_44_110/0.2)] dark:bg-brand-soft'
              : 'text-muted hover:text-ink',
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
